import { Observable } from 'rxjs';
import { User as GraphUser } from '@microsoft/microsoft-graph-types';

export class User {
  // The user principal name and identifier in db.
  public PdpUserId: number;
  public UpnId: string;
  public Role: number;
  public MsGraphUser$: Observable<GraphUser>;

  constructor(opt?: Partial<User>) {
    Object.assign(this, opt);
  }
}
